var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contactUs"},[_c('div',{staticClass:"header"},[_vm._v(_vm._s(_vm.$t("contactUs.contactUs")))]),_c('ContactUs')],1)}
var staticRenderFns = []

export { render, staticRenderFns }